import React from 'react';

export type DeliveryMethod = 'standard' | 'express';

interface DeliveryOptionsProps {
    value: DeliveryMethod;
    onChange: (method: DeliveryMethod) => void;
}

const OPTIONS: {method: DeliveryMethod; label: string; price: string; description: string}[] = [
    {method: 'standard', label: 'Standard', price: 'Free!', description: '2–8 business days'},
    {method: 'express', label: 'Express', price: '$30.00', description: '1–3 business days'},
];

const DeliveryOptions: React.FC<DeliveryOptionsProps> = ({value, onChange}) => {
    return (
        <div>
            <h3 className="text-sm font-semibold text-mld-text-primary mb-3">Select delivery option</h3>
            <div className="space-y-2">
                {OPTIONS.map((opt) => (
                    <label
                        key={opt.method}
                        className={`flex items-center gap-3 p-4 rounded-lg border cursor-pointer transition-colors ${
                            value === opt.method
                                ? 'border-mld-success bg-mld-success/5'
                                : 'border-gray-300 hover:border-mld-panel-border'
                        }`}>
                        <input
                            type="radio"
                            name="delivery"
                            value={opt.method}
                            checked={value === opt.method}
                            onChange={() => onChange(opt.method)}
                            className="accent-mld-success"
                        />
                        <div className="flex-1">
                            <span className="text-sm font-medium text-mld-text-primary">
                                {opt.label} – {opt.price}
                            </span>
                            <p className="text-xs text-mld-muted-text">{opt.description}</p>
                        </div>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default DeliveryOptions;
